import React, { useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { useDefaultImage } from "../hooks/useInventory";

const ItemImage = ({ image, className, id, alt, onClick }) => {
  const [isHover, setIsHover] = useState(false);
  const defaultImage = useDefaultImage();

  const imageEntry = image || null;
  let imageSrc = imageEntry?.uri || defaultImage;

  const alternativeSrc = imageEntry?.alternative?.uri;
  if (isHover && alternativeSrc) imageSrc = alternativeSrc;

  return <LazyLoadImage className={className || ""} id={id} alt={alt} title={alt} src={imageSrc} onClick={e => (onClick ? onClick() : null)} onMouseEnter={e => setIsHover(true)} onMouseLeave={e => setIsHover(false)} />;
};

export default ItemImage;
